
/**
 * ConveniPoolOp.js
 */

class ConveniPoolOp {

    constructor() {};


    setDataObj( dataObj ) {

        let resultDataArr = dataObj['nbResult'].array;
        this._highPoolArray = dataObj['highPool'].array;
        this._high2PoolArray = dataObj['high2Pool'].array;
        this._or34 = this._highPoolArray[0].or34;

        this._dataHangar = new DataHangar( resultDataArr, this._or34);
        
        this._highContArray = PoolContents.poolContentsListMaker( this._highPoolArray );
        this._high_2_ContArray = PoolContents.poolContentsListMaker( this._high2PoolArray );
        this.setHighPoolFillStateContents();

        
        this._customDataList = [];
        this.setCustomDataList( dataObj['custom-jiku'], dataObj['custom-jyo']);
        this.setFillStateCustomArray();
        //
        this._target = dataObj['target-size'];
        //
        this._processValue = dataObj['processValue'];
        //

        this._totalDefBooArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
        this._totalDefCount = this._totalDefBooArray.length;
       
        this._totalDupBooArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
        this._totalDupCount = this._totalDupBooArray.length;

        this._defSize = this._totalDefCount;
        this._dupSize = this._totalDupCount;

        //  custom
        this._totalDefBooCustomArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
        this._totalDefCustomCount = this._totalDefBooCustomArray.length;

        this._totalDupBooCustomArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
        this._totalDupCustomCount = this._totalDupBooCustomArray.length;

        //  predict
        this._predictChoiceContArray = [];

        this._pick30 = [];
        this._pick30_index = 0;

        //
        this.setAddCustomArrayAndHigh_2_pool();


    };



    defDupBooArrayClear() {

        this._totalDefBooArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
        this._totalDefCount = this._totalDefBooArray.length;
       
        this._totalDupBooArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
        this._totalDupCount = this._totalDupBooArray.length;

        //  custom
        this._totalDefBooCustomArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
        this._totalDefCustomCount = this._totalDefBooCustomArray.length;

        this._totalDupBooCustomArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
        this._totalDupCustomCount = this._totalDupBooCustomArray.length;
    };


    setHighPoolFillStateContents() {
        for(let i=0, n=this._highContArray.length; i<n; i++) {
            this.setFillStateContents( this._highContArray[i] );
        };
        for(let i=0, n=this._high_2_ContArray.length; i<n; i++) {
            this.setFillStateContents( this._high_2_ContArray[i] );
        };
    };


    setCustomDataList(jikuData, jyoData) {

        let list = [];
        if( ! jikuData[10] ) {
            let bit1Jiku = 0;
            for(let i=1; i<=this._or34; i++) {  bit1Jiku += Math.pow(2,i);  };
            let bit2Jiku = 0;
            for(let i=0; i<10; i++) {   bit2Jiku += jikuData[i] ? Math.pow(2,i) : 0;   };
            let cont = { or34: this._or34, cag: 1, pls: 0, bit1: bit1Jiku, bit2: bit2Jiku  };
            list.push( cont );
        };
        if(! jyoData[10]) {
            let bit1Jyo = 1;
            let bit2Jyo = 0;
            let cag = 0;
            for(let i=0; i<10; i++) {
                cag += jyoData[i] ? 1 : 0;
                bit2Jyo += jyoData[i] ? Math.pow(2,i) : 0;
            };
            let cont = { or34: this._or34, cag: cag, pls: 0, bit1: bit1Jyo, bit2: bit2Jyo  };
            list.push( cont );
        };
        this._customDataList = PoolContents.poolContentsListMaker(list);

    };

    //
    setFillStateCustomArray() {
        for(let i=0, n=this._customDataList.length; i<n; i++) {
            this.setFillStateContents( this._customDataList[i] );
        };
    };



    //
    setAddCustomArrayAndHigh_2_pool() {

        this.defDupBooArrayClear();

        for(let i=0, n=this._customDataList.length; i<n; i++) {
            let cont = this._customDataList[i];
            this.reflectDefDupCustomArray(cont);
        };

        let targetMaxSize = 50;
        let targetMinSize = (this._target+3)*4;

        if(this._totalDupCustomCount<=targetMinSize) {
            //  スルー
        }else {

            let indexArray = this.makeIndexArray( this._high_2_ContArray );
            MyUtility.randomSort( indexArray );

            for(let i=0, n=indexArray.length; i<n; i++) {
                let high2Cont = this._high_2_ContArray[indexArray[i]];
                let kariBoo = this.karinoReflectBooArray( this._totalDupBooCustomArray, high2Cont.booDupArray);
                let count = MyUtility.arrayCount( kariBoo, true );
                if(count <= targetMinSize) {
                    break;
                }else {
                    this.reflectDefDupCustomArray( high2Cont );
                };
            };
        };

        this.totalDefDupBooForCustom();

    };
    makeIndexArray(targetArray) {
        let size = targetArray.length;
        let result = [];
        for(let i=0; i<size; i++) {
            result.push(i);
        };
        return result;
    };



    setFillStateContents(cont) {

        //  predData 作成  copyAに プロパティを追加
        let categFact = this._dataHangar.getCategFactory( cont.categ);
        let booArr = categFact.getMakeResultBooArray( cont.bit1Arr, cont.bit2Arr, cont.plus );
        //  プロパティ名 'booArray' 設定
        cont.booArray = booArr;
        let booDef = categFact.getMakeDefBooArray(cont.bit1Arr, cont.bit2Arr, true);
        //  プロパティ名 'booDefArray' 設定
        cont.booDefArray = booDef;
        cont.totalPa = MyUtility.arrayCount( booDef, 1 )/Math.pow( 10, cont.or34-2);
        let booDup = categFact.getMakeDefBooArray(cont.bit1Arr, cont.bit2Arr, false);
        //  プロパティ名 'booDupArray' 設定
        cont.booDupArray = booDup;

        let defCount = MyUtility.arrayCount( booDef, 1 );
        let predData = this._dataHangar.makePredictData( booArr, defCount);
        //  プロパティ名 'predData' 設定
        cont.predData = predData;
    };

    reflectDefDupCustomArray(cont) {
        let booDef = cont.booDefArray;
        let booDup = cont.booDupArray;

        this.reflectBooArray( this._totalDefBooCustomArray, booDef);
        this._totalDefCustomCount = MyUtility.arrayCount( this._totalDefBooCustomArray, true );

        this.reflectBooArray( this._totalDupBooCustomArray, booDup);
        this._totalDupCustomCount = MyUtility.arrayCount( this._totalDupBooCustomArray, true );

    };

    reflectBooArray(target, reflect) {

        for(let i=0, n=target.length; i<n; i++) {
            if( ! reflect[i] ) {
                target[i] = false;
            };
        };
    };


    karinoReflectBooArray(target, reflect) {
        let copy = MyUtility.copyArray(target);
        this.reflectBooArray( copy, reflect );
        return copy;
    };


    totalDefDupBooForCustom() {

        for(let i=0, n=this._totalDefBooArray.length; i<n; i++) {
            if( ! this._totalDefBooCustomArray[i] ) { this._totalDefBooArray[i] = false; };
        };
        for(let i=0, n=this._totalDupBooArray.length; i<n; i++) {
            if( ! this._totalDupBooCustomArray[i] ) { this._totalDupBooArray[i] = false; };
        };

        this._totalDefCount = MyUtility.arrayCount( this._totalDefBooArray, true );
        this._totalDupCount = MyUtility.arrayCount( this._totalDupBooArray, true );

    };

    
    //  prediction
    makePickup30Array() {

        let targetCount = Math.floor(this._totalDupCount*this._processValue);

        let copyB = [];

		for(let i=0, n=this._highContArray.length; i<n; i++) {

			let booDup = this._highContArray[i].booDupArray;

			let tempArr = MyUtility.makeFillArray( booDup.length, false);
			for(let j=0, m=booDup.length; j<m; j++) {
				if(this._totalDupBooArray[j] && booDup[j]===1 ) {
					tempArr[j] = true;
				};
			};

			let count = MyUtility.arrayCount( tempArr, true );

            let abs = Math.abs( targetCount - count );
            let sign = Math.sign(targetCount - count);
            let gap = targetCount - count;
            //  copyDefContArrayの当該要素PoolContentsオブジェクトに diffAbsプロパティ追加
            if(this._totalDupCount !== count) {
                let copyCt = this._highContArray[i];
                copyCt.dupCt = count;
                copyCt.diffAbs = abs;
                copyCt.sign = sign;
                copyCt.gap = gap;
                copyB.push( copyCt );
            };
        };

        //copyB.sort( (a,b) => a.diffAbs - b.diffAbs );
        copyB.sort( (a, b) => (a.diffAbs - b.diffAbs)*100+( b.totalPa - a.totalPa ) );


		let pickup30 = [];

		let len = 30;
		if( copyB.length < len ) {   len =  copyB.length;  };


        let count = 0;
        for(let i=0, n=copyB.length; i<n; i++) {
			let cont = copyB[i];
            let boo = true;
            for(let j=0, m=pickup30.length; j<m; j++) {
                if(pickup30[j].diffAbs===cont.diffAbs) {
                    if( this.lastBooArrayEquals( pickup30[j].booArray, cont.booArray, 40 ) ) {
                        boo = false;
                    };
                };
            };
            if(boo) {
                pickup30.push(cont);
                count++;
                if(count===len) {   break;   };
            };
        };
        /*
		for(let i=0; i<len; i++) {
			let copy = copyB[i];
			//  プロパティ名 'copyArrayIndex' 設定
            //copy.copyArrayIndex = i;
            pickup30.push(copy);
        };
        */
        
        //pickup30.sort( (a, b) => (a.diffAbs - b.diffAbs)*100+( b.totalPa - a.totalPa ) );

        this._pick30_index = 0;

        this._pick30 = pickup30;

        return pickup30;
        
    };
    lastBooArrayEquals( target1, target2, lastCount ) {
        let boo = true;
        for(let i=target1.length-lastCount, n=target1.length; i<n; i++) {
            if(target1[i] !== target2[i]) {   boo = false;  break;   };
        };
        return boo;
    };

    pickup3(contList, index) {

        let pick3 = [];
        if(contList.length<=3) {
            for(let i=0, n=contList.length; i<n; i++) {
                pick3.push( contList[i] );
            };
        }else {
            let size = contList.length;
            for(let i=0; i<3; i++) {
                pick3.push( contList[ (i+index)%size ] );
            };
        };
        return pick3;
    };
    
    pickup3Choice( cont ) {
        
        this._predictChoiceContArray.push( cont );
        let booDef = cont.booDefArray;
        let booDup = cont.booDupArray;

        let kariBoo = this.karinoReflectBooArray(this._totalDupBooArray , booDup);
        let count = MyUtility.arrayCount( kariBoo, true );
        if(this._target>count) {

            return null;

        }else if(this._target+2>count) {
            this.reflectBooArray( this._totalDefBooArray, booDef);
            this._totalDefCount = MyUtility.arrayCount( this._totalDefBooArray, true );
    
            this.reflectBooArray( this._totalDupBooArray, booDup);
            this._totalDupCount = MyUtility.arrayCount( this._totalDupBooArray, true );
    
            return null;
        }else {
            this.reflectBooArray( this._totalDefBooArray, booDef);
            this._totalDefCount = MyUtility.arrayCount( this._totalDefBooArray, true );
    
            this.reflectBooArray( this._totalDupBooArray, booDup);
            this._totalDupCount = MyUtility.arrayCount( this._totalDupBooArray, true );
    
            this._pick30 = this.makePickup30Array();

            if(this._pick30.length===0) {
                return null;
            }else {
                return this.pickup3( this._pick30, 0);
            };
            
        };
    
    };

    predictPassProcess(pick3Array) {

        this._pick30_index = (this._pick30_index+pick3Array.length)%this._pick30.length;

        return this.pickup3( this._pick30, this._pick30_index );
    };

    predictReturnProcess() {

        let size = this._predictChoiceContArray.length;
        if(size===0) {

            this._pick30 = this.makePickup30Array();
            return this.pickup3( this._pick30, 0);

        }else {
            this._predictChoiceContArray.pop();
            
            this._totalDefBooArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
            this.reflectBooArray( this._totalDefBooArray, this._totalDefBooCustomArray);
            this._totalDefCount = MyUtility.arrayCount( this._totalDefBooArray, true );

            this._totalDupBooArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
            this.reflectBooArray( this._totalDupBooArray, this._totalDupBooCustomArray);
            this._totalDupCount = MyUtility.arrayCount( this._totalDupBooArray, true );

            for(let i=0, n=this._predictChoiceContArray.length; i<n; i++) {
                this.reflectBooArray( this._totalDefBooArray, this._predictChoiceContArray[i].booDefArray);
                this.reflectBooArray( this._totalDupBooArray, this._predictChoiceContArray[i].booDefArray);
            };

            this._pick30 = this.makePickup30Array();
            return this.pickup3( this._pick30, 0);
        };
    };

    predictChoiceClear(isMakePick30 = false) {

        this._predictChoiceContArray = [];

        this._totalDefBooArray = MyUtility.makeFillArray( this._dataHangar.nbDef.length, true);
        this._totalDefCount = this._totalDefBooArray.length;
       
        this._totalDupBooArray = MyUtility.makeFillArray( this._dataHangar.nbDefDup.length, true);
        this._totalDupCount = this._totalDupBooArray.length;

        this.totalDefDupBooForCustom();

        this._pick30_index = 0;

        if(isMakePick30) {  this._pick30 = this.makePickup30Array();  };

    };



    //  result
    makeResultList( isJust, target ) {

        let resultList = [];
        for(let i=0, n=this._totalDupBooArray.length; i<n; i++) {
            if(this._totalDupBooArray[i]) {
                resultList.push( this._dataHangar.nbDefDup[i].join('') );
            };
        };

        if(isJust) {
            if(target !== resultList.length) {
                this.randomRemoveList( resultList, resultList.length-target );
            };
        };

        return resultList;
    };

    randomRemoveList( targetArray, count ) {
        for(let i=0; i<count; i++) {
            targetArray.splice(Math.floor(Math.random()*targetArray.length), 1);
        };
    };


};